import React from "react"

const IconComplete = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 0C8.95 0 0 8.95 0 20C0 31.04 8.95 40 20 40C31.04 40 40 31.04 40 20C40 8.95 31.04 0 20 0ZM16 30L6 20L8.83 17.17L16 24.34L31.17 9.17L34 12L16 30Z" fill="#2BA770"/>
  </svg>
)

export default IconComplete
